import React from "react";
import { Card, List, Tabs, theme, Tooltip, Typography, } from 'antd';
import { BookOutlined } from "@ant-design/icons";
import { URL_COMMON } from "../constants/urls";
import { GET } from "../frameworks/HttpClient";
import ColorButton from "../common/ColorButton";
import { PRINT_COLOR } from "../constants/color";
import ErrorMessages from "../common/ErrorMessages";

export default function ManualView() {
  const [manuals, setManuals] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [errorMessages, setErrorMessages] = React.useState()

  const fetchMannual = async() => {
    setLoading(true)
    try {
      const reponse = await GET(URL_COMMON.MANNUAL)
      setManuals(reponse.data)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const data = [
    {
      name : 'คู่มือการใช้งาน - การรับซื้อน้ำยางสด',
      url : manuals.recieving_raw_latex_manual
    },
    {
      name : 'คู่มือการใช้งาน - การจัดการบ่อพักน้ำยางสด',
      url : manuals.raw_latex_pond_manual
    },
    {
      name : 'คู่มือการใช้งาน - การจัดการน้ำยางข้น',
      url : manuals.concentrate_latex_tank_manual
    },
    {
      name : 'คู่มือการใช้งาน - การจัดการยางสกิม',
      url : manuals.skim_manual
    },
    {
      name : 'คู่มือการใช้งาน - การจัดการสารเคมี',
      url : manuals.chemical_manual
    },
    {
      name : 'คู่มือการใช้งาน - การจัดการขาย',
      url : manuals.selling_manual
    },
  ]


  React.useEffect(() => {
    fetchMannual()
  },[])

  return(
    <div style={{ marginTop : 30}}>
      <ErrorMessages messege={errorMessages}/>
      <List
        header={<div style={{ fontWeight : 'bolder'}}>คู่มือการใช้งานโปรแกรม</div>}
        bordered
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <Tooltip title={item.url ? '' : "ไม่พบคู่มือ"} >
              <ColorButton
                type='primary'
                override={PRINT_COLOR}
                style={{marginRight : 15}}
                icon={<BookOutlined/>}
                loading={loading}
                onClick={() => window.open(item.url)}
                disabled={item.url ? false : true}
              >
                Download
              </ColorButton>
            </Tooltip>
            {item.name}
          </List.Item>
        )}
      />
    </div>
  )
}